window.addEventListener('load', function() {
    moveTodayScrollMainCalendar();

    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var today = date.getDate();

    function setoday() {
        var caltop = document.querySelector('table.calendar tbody').offsetTop;
        pos = document.querySelector('tr#month2').offsetTop - caltop + h * (today - 1);
        smoothScroll(pos);
    }

    function moveweek() {
        smoothScroll(pos);
    }
    function smoothScroll(element, targetPosition, duration) {
        let startTime = null;

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = ease(timeElapsed, element.scrollTop, targetPosition - element.scrollTop, duration);
            element.scrollTop = run;
            if (timeElapsed < duration) requestAnimationFrame(animation);
        }

        function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    }

    function moveTodayScrollMainCalendar() {
        console.log('loaded');

        // var tbody = document.getElementById("scroll-main-cal");
        var wrapper = document.getElementsByClassName("calendar-wrap")[0];
        var tbody = document.getElementById("scroll-main-cal");
        var todayRow = tbody.getElementsByClassName("today")[0];
        console.log('today:' + todayRow.offsetTop);
        console.log('body:' + tbody.offsetTop)
        if (todayRow && tbody) {
            smoothScroll(wrapper, todayRow.offsetTop - tbody.offsetTop, 500);
        }
    };
});
